import { useEffect, useRef, useCallback } from 'react';
/**
 * A callback that can be called at any time to check if this component is still mounted.
 * Useful for dealing with async operations and avoiding state changes on unmounted components
 * @returns The callback function. Is memoised so will be stable across the lifecycle of the component
 */
export default function useGetIsMounted() {
  const isMountedRef = useRef(true);
  useEffect(() => {
    return () => {
      isMountedRef.current = false;
    };
  }, []);
  return useCallback(() => isMountedRef.current, []);
}